import * as React from "react";
import {
  Box,
  Slide,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  CircularProgress,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmPopup({
  open,
  handleClose,
  message,
  id,
  loading, // New loading prop
}) {
  const { t } = useTranslation("common");

  return (
    <Box color="default">
      <Dialog
        open={open}
        onBackdropClick={() => handleClose(false)}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleClose(false)}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(12px)",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.37)",
            color: "#ffffff",
            borderRadius: 16,
            padding: 16,
            border: "1px solid rgba(255, 255, 255, 0.2)",
          },
        }}
      >
        <DialogContent>
          {/* 
            Override the underlying tag with `component="div"` 
            so this won't be a <p> nesting block elements.
          */}
          <DialogContentText component="div" align="center">
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              message
            )}
          </DialogContentText>
        </DialogContent>

        {!loading && (
          <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              style={{
                width: "50%",
                padding: "10px 45px",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                color: "#ffffff",
              }}
              onClick={() => handleClose(false)}
            >
              {t("confirmPopup.button1")}
            </Button>
            <Button
              style={{
                width: "50%",
                padding: "10px 45px",
                backgroundColor: "#FFD700",
                color: "#000000",
              }}
              variant="contained"
              onClick={() => handleClose(true)}
            >
              {t("confirmPopup.button2")}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    </Box>
  );
}
